import {
    APP_INIT_FAILURE,
    APP_INIT_START,
    APP_INIT_SUCCESS,
    APP_LOG,
    CLOSE_MODAL,
    COMPLETE_ONBOARDING_FAILURE,
    COMPLETE_ONBOARDING_START,
    COMPLETE_ONBOARDING_SUCCESS,
    LOAD_ACCOUNT_HISTORY_FAILURE,
    LOAD_ACCOUNT_HISTORY_INFO_FAILURE,
    LOAD_ACCOUNT_HISTORY_INFO_START,
    LOAD_ACCOUNT_HISTORY_INFO_SUCCESS,
    LOAD_ACCOUNT_HISTORY_START,
    LOAD_ACCOUNT_HISTORY_SUCCESS,
    LOAD_ACCOUNT_TRADE_INFO_FAILURE,
    LOAD_ACCOUNT_TRADE_INFO_START,
    LOAD_ACCOUNT_TRADE_INFO_SUCCESS,
    LOG_ACTION,
    LOG_APPSFLYER_ACTION,
    OPEN_MODAL,
    RESET_FORM_ERROR,
    SET_IS_FIRST_LOGIN,
    SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE,
    SET_IS_OPEN_RESPAWN_BANNER_VISIBLE,
    SET_RECENT_DONE,
    SET_USER_SELECTED_ACCOUNT_CODE,
    UPDATE_AB_TEST_IS_USED_FAILURE,
    UPDATE_AB_TEST_IS_USED_START,
    UPDATE_AB_TEST_IS_USED_SUCCESS,
    USER_PROMOCODE_APPLY_FAILURE,
    USER_PROMOCODE_APPLY_START,
    USER_PROMOCODE_APPLY_SUCCESS,
    USER_PROMOCODE_REMOVE_FAILURE,
    USER_PROMOCODE_REMOVE_START,
    USER_PROMOCODE_REMOVE_SUCCESS,
    USER_UPDATE_FAILURE,
    USER_UPDATE_PASSWORD_FAILURE,
    USER_UPDATE_PASSWORD_START,
    USER_UPDATE_PASSWORD_SUCCESS,
    USER_UPDATE_START,
    USER_UPDATE_SUCCESS,
} from "./appConstants";
import createAction from "./createAction";

export const appInitAction = (payload) => createAction(APP_INIT_START, payload);
export const appInitSuccess = (payload) => createAction(APP_INIT_SUCCESS, payload);
export const appInitFailure = (payload) => createAction(APP_INIT_FAILURE, payload);

export const appLog = (payload) => createAction(APP_LOG, payload);
export const logAction = (payload) => createAction(LOG_ACTION, payload);
export const logAppsflyerAction = (payload) => createAction(LOG_APPSFLYER_ACTION, payload);

export const openModalAction = (payload) => createAction(OPEN_MODAL, payload);
export const closeModalAction = (payload) => createAction(CLOSE_MODAL, payload);

export const userUpdateAction = (payload) => createAction(USER_UPDATE_START, payload);
export const userUpdateSuccess = (payload) => createAction(USER_UPDATE_SUCCESS, payload);
export const userUpdateFailure = (payload) => createAction(USER_UPDATE_FAILURE, payload);

export const userUpdatePasswordAction = (payload) => createAction(USER_UPDATE_PASSWORD_START, payload);
export const userUpdatePasswordSuccess = (payload) => createAction(USER_UPDATE_PASSWORD_SUCCESS, payload);
export const userUpdatePasswordFailure = (payload) => createAction(USER_UPDATE_PASSWORD_FAILURE, payload);

export const userPromocodeApplyAction = (payload) => createAction(USER_PROMOCODE_APPLY_START, payload);
export const userPromocodeApplySuccess = (payload) => createAction(USER_PROMOCODE_APPLY_SUCCESS, payload);
export const userPromocodeApplyFailure = (payload) => createAction(USER_PROMOCODE_APPLY_FAILURE, payload);

export const userPromocodeRemoveAction = (payload) => createAction(USER_PROMOCODE_REMOVE_START, payload);
export const userPromocodeRemoveSuccess = (payload) => createAction(USER_PROMOCODE_REMOVE_SUCCESS, payload);
export const userPromocodeRemoveFailure = (payload) => createAction(USER_PROMOCODE_REMOVE_FAILURE, payload);

export const setIsFirstLoginAction = (payload) => createAction(SET_IS_FIRST_LOGIN, payload);

export const completeOnboardingAction = (payload) => createAction(COMPLETE_ONBOARDING_START, payload);
export const completeOnboardingSuccess = (payload) => createAction(COMPLETE_ONBOARDING_SUCCESS, payload);
export const completeOnboardingFailure = (payload) => createAction(COMPLETE_ONBOARDING_FAILURE, payload);

export const resetFormErrorAction = (payload) => createAction(RESET_FORM_ERROR, payload);

export const updateAbTestIsUsedAction = (payload) => createAction(UPDATE_AB_TEST_IS_USED_START, payload);
export const updateAbTestIsUsedSuccess = (payload) => createAction(UPDATE_AB_TEST_IS_USED_SUCCESS, payload);
export const updateAbTestIsUsedFailure = (payload) => createAction(UPDATE_AB_TEST_IS_USED_FAILURE, payload);

export const loadAccountTradeInfoAction = (payload) => createAction(LOAD_ACCOUNT_TRADE_INFO_START, payload);
export const loadAccountTradeInfoSuccess = (payload) => createAction(LOAD_ACCOUNT_TRADE_INFO_SUCCESS, payload);
export const loadAccountTradeInfoFailure = (payload) => createAction(LOAD_ACCOUNT_TRADE_INFO_FAILURE, payload);

export const setRecentDoneAction = (payload) => createAction(SET_RECENT_DONE, payload);
export const setUserSelectedAccountCode = (payload) => createAction(SET_USER_SELECTED_ACCOUNT_CODE, payload);

export const setIsOpenMobileAppBannerVisibleAction = (payload) => createAction(SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE, payload);

export const loadAccountHistoryAction = (payload) => createAction(LOAD_ACCOUNT_HISTORY_START, payload);
export const loadAccountHistorySuccess = (payload) => createAction(LOAD_ACCOUNT_HISTORY_SUCCESS, payload);
export const loadAccountHistoryFailure = (payload) => createAction(LOAD_ACCOUNT_HISTORY_FAILURE, payload);

export const loadAccountHistoryInfoAction = (payload) => createAction(LOAD_ACCOUNT_HISTORY_INFO_START, payload);
export const loadAccountHistoryInfoSuccess = (payload) => createAction(LOAD_ACCOUNT_HISTORY_INFO_SUCCESS, payload);
export const loadAccountHistoryInfoFailure = (payload) => createAction(LOAD_ACCOUNT_HISTORY_INFO_FAILURE, payload);

export const setIsOpenRespawnBannerVisibleAction = (payload) => createAction(SET_IS_OPEN_RESPAWN_BANNER_VISIBLE, payload);
